// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1JtPO","colMin":"styles_colMin__15zrw","colCheckbox":"styles_colCheckbox__hwckG"};